import { REDIRECT_AFTER_LOGIN_KEY } from 'features/auth/constants';
import { broadcastLogout } from 'features/auth/helpers/crossTab';
import { clearAuthToken } from 'features/auth/helpers/helpers';
import { cleanupPushSubscriptionOnLogout } from 'features/push-notification/helpers';
import { useAppDispatch } from 'lib/stores/hook';
import { useCallback } from 'react';
import { getPath } from 'routes/router-paths';

/**
 * Shared logout hook across the application.
 *
 * Clears local tokens, broadcasts logout to other tabs, cleans up FCM push subscriptions,
 * and hard-redirects to `/auth/login` to ensure Redux store and cache reset.
 *
 * @returns A callback function to execute the logout process.
 */
export const useLogout = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    const finishLogout = async () => {
      // Clear saved post-login redirect URL (if any) when the user explicitly logs out
      sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);

      // Await FCM push subscription cleanup BEFORE clearing auth tokens — DELETE /me/push-subscriptions requires Bearer auth.
      await cleanupPushSubscriptionOnLogout(dispatch);

      clearAuthToken();
      broadcastLogout();
      window.location.replace(getPath('loginPage'));
    };

    void finishLogout();
  }, [dispatch]);
};
